import { Component, inject } from '@angular/core';
import { ProvenueErrorService } from '@core/services/provenue-error.service';
import { environment } from '@environments/environment';
import { DvmService } from '@features/digital-venue/services/dvm.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  selector: 'app-modals',
  templateUrl: './modals.component.html',
  styleUrls: ['./modals.component.css'],
})
export class ModalsComponent {
  provenueErrorService = inject(ProvenueErrorService);
  title: string;
  content: string;
  closeBtnName: string;
  compact = false;
  acceptBtnName: string;
  closeFunction: () => void;
  acceptFunction: () => void;

  // Legend
  availableColor: string = 'main-light';
  mySeatsColor: string = 'red';
  selectedColor: string = 'purple';
  isolatedColor: string = 'orange';

  bsModalRef = inject(BsModalRef);
  private dvmService = inject(DvmService);

  get isTopview() {
    return this.dvmService.isTopview;
  }

  accept() {
    this.bsModalRef.hide();
    if (this.acceptFunction) {
      this.acceptFunction();
    }
  }

  close() {
    this.bsModalRef.hide();
    if (this.closeFunction) {
      this.closeFunction();
    }
  }

  get showProvenueErrorInfo() {
    const hasPvErrorId =
      this.provenueErrorService.getPvRequestId() ||
      this.provenueErrorService.getPvProxyRequestId();
    return environment.showProvenueErrorInfo && hasPvErrorId;
  }
}
